/*
 * @fileOverView Banner component definition
 */

import Vue from 'vue';

/**
 * Banner Vue
 * @type {class}
 */
Vue.component('banner-vue', {
  props: {
    'id': 0
  },

  data: function() {
    return {
      dismissed: true,
      first: false
    }
  },

  computed: {
    cookieIds: function () {
      return {
        dismissed: `mjff-banner-dismissed--${this.id}`,
        repeat: `mjff-banner-repeat--${this.id}`
      }
    }
  },

  mounted() {
    // Tracks whether or not the banner was dismissed on a prior page.
    if (!this.getCookie(this.cookieIds.dismissed)) {
      this.dismissed = false;
    }

    // Tracks whether or not the user has already seen the banner. If not, a
    // class will be added that triggers a subtle animation on the content.
    if (!this.getCookie(this.cookieIds.repeat)) {
      this.setCookie(this.cookieIds.repeat, true, 7);
      this.first = true;
    }
  },

  methods: {
    handleDismiss() {
      this.setCookie(this.cookieIds.dismissed, true, 7);
      this.dismissed = true;
    },

    // Uses cookies instead of local storage so that they don't persist beyond
    // the browser being closed (per business requirements).
    // @see https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/

    getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    },

    setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }
  }
});
